
import { useLocation } from 'react-router-dom';

import React, { useState,useEffect,useContext } from 'react';
import './SideBar.scss';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import image  from '../../assests/logo.svg'
import { getLogoName ,listenToEvent, removeListener } from '../../Helpers/utils';
import {getRole} from '../../Helpers/utils'
import { UserInfo } from "../../Context/userInfo";
const SideBar = ({ isOpen, toggleSidebar }) => {

  const { userData, updateUserData } = useContext(UserInfo);
  const [roles,setRoles]=useState(null)

  const navigate = useNavigate();
  useEffect(()=>{
if(userData){
  setRoles( getRole(userData.data?.userInfo?.roles))
}


  },[userData])





    const [showClass, setShowClass] = useState('');
  const setToggle = (data) => {
    setShowClass((prev) => (prev === data ? '' : data));
  };




  return (
    <div className={`sidebar ${isOpen ? 'open' : 'close'}`}>
      <div className="logo-details">
 <Link style={{textDecoration:'none'}}>
       <div className="logo-resize">


       {!isOpen ?  <img
                    src={image}
                       style={{ height: "60px" }}
                      alt="Logo"
                    />: <div className='d-flex' style={{marginLeft:'-10%'}}><img
                    src={image}
                       style={{ height: "60px"}}
                      alt="Logo"
                    /><div style={{ marginTop: '5%',
                    fontFamily: 'Myriad Pro',
                    fontSize: 'xx-large',
                    color: 'whitesmoke'}}>1Dallas</div></div>}

                    </div>
</Link>

      </div>
      <ul className="nav-links">


      <li onClick={() => setToggle('Dashboard')}>
          <div className={`icon-link ${showClass == 'Dashboard' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/Dashboard")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-line-chart'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}>Dashboard</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'Dashboard' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Dashboard'); // Ensure the submodule stays open
            navigate("/Dashboard")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-line-chart'></i>
                <span className={`${showClass != 'Dashboard' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}>Dashboard</span>
            </Link>
        </li>
    </ul>





        </li>


     {roles== 'Admin' &&   <li onClick={() => setToggle('Agent-care')}>
          <div className={`icon-link ${showClass == 'Agent-care' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/Agent-care")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-support'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}>Agent Care</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'Agent-care' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Agent-care'); // Ensure the submodule stays open
            navigate("/Agent-care")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-support'></i>
                <span className={`${showClass != 'Agent-care' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}>Agent Care</span>
            </Link>
        </li>
    </ul>





        </li>}

       {roles== 'Agent' && <li onClick={() => setToggle('My-tickets')}>
          <div className={`icon-link ${showClass == 'My-tickets' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/my-tickets")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-help-circle'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}>My Tickets</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'My-tickets' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('My-tickets'); // Ensure the submodule stays open
            navigate("/my-tickets")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-help-circle'></i>
                <span className={`${showClass != 'My-tickets' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}>My Tickets</span>
            </Link>
        </li>
    </ul>





        </li>}

       <li onClick={() => setToggle('publishing-panel')}>
          <div className={`icon-link ${showClass == 'publishing-panel' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/publishing-panel")}}>
            <Link className="loginhere-link" >
              <i className='bx bx bx-bell'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}> Publishing Panel</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'publishing-panel' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('publishing-panel'); // Ensure the submodule stays open
            navigate("/publishing-panel")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx bx-bell'></i>
                <span className={`${showClass != 'publishing-panel' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}> Publishing Panel</span>
            </Link>
        </li>
    </ul>





        </li>

        <li onClick={() => setToggle('Departments')}>
          <div className={`icon-link ${showClass == 'Departments' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/Departments")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-building'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}> Departments</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'Departments' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Departments'); // Ensure the submodule stays open
            navigate("/Departments")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-building'></i>
                <span className={`${showClass != 'Departments' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}> Departments </span>
            </Link>
        </li>
    </ul>





        </li>

        <li onClick={() => setToggle('Plugin Support')}>
          <div className={`icon-link ${showClass == 'Plugin Support' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/PluginSupport")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-plug'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}> Plugin Support</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'Plugin Support' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Plugin Support'); // Ensure the submodule stays open
            navigate("/PluginSupport")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-plug'></i>
                <span className={`${showClass != 'Plugin Support' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}> Plugin Support </span>
            </Link>
        </li>
    </ul>





        </li>
        <li onClick={() => setToggle('Call care support')}>
          <div className={`icon-link ${showClass == 'Call care support' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/Call-care-support")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-phone-call'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}> Call care support</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'Call care support' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Call care support'); // Ensure the submodule stays open
            navigate("/Call-care-support")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-phone-call'></i>
                <span className={`${showClass != 'Call care support' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}> Call care support </span>
            </Link>
        </li>
    </ul>





        </li>
        <li onClick={() => setToggle('Custom View')}>
  <div className={`icon-link ${showClass === 'Custom View' ? "icon-link1" : ''}`} onClick={() => navigate("/Custom View")}>
    <Link className="loginhere-link">
      <i className='bx bx-customize'></i> {/* Custom View Icon */}
      <span className="link_name" style={{ color: '#dfdfdf' }}>Custom View</span>
    </Link>
  </div>
  <ul className="sub-menu" style={{ padding: '12px 12px', backgroundColor: "rgba(31,41,53,255)" }}>
    <li className={`li-setting icon-link ${showClass === 'Custom View' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
      e.stopPropagation();
      setShowClass('Custom View');
      navigate("/Custom View");
    }}>
      <Link className="loginhere-link" style={{ padding: "0px 20px" }}>
        <i className='bx bx-customize'></i>
        <span className={`${showClass !== 'Custom View' ? "link_name1" : 'link_name2'}`} style={{ color: '#dfdfdf' }}>Custom View</span>
      </Link>
    </li>
  </ul>
</li>

<li onClick={() => setToggle('Data service and apis')}>
  <div className={`icon-link ${showClass === 'Data service and apis' ? "icon-link1" : ''}`} onClick={() => navigate("/DataService")}>
    <Link className="loginhere-link">
      <i className='bx bx-code-alt'></i> {/* Data/APIs Icon */}
      <span className="link_name" style={{ color: '#dfdfdf' }}>Data service and APIs</span>
    </Link>
  </div>
  <ul className="sub-menu" style={{ padding: '12px 12px', backgroundColor: "rgba(31,41,53,255)" }}>
    <li className={`li-setting icon-link ${showClass === 'Data service and apis' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
      e.stopPropagation();
      setShowClass('Data service and apis');
      navigate("/DataService");
    }}>
      <Link className="loginhere-link" style={{ padding: "0px 20px" }}>
        <i className='bx bx-code-alt'></i>
        <span className={`${showClass !== 'Data service and apis' ? "link_name1" : 'link_name2'}`} style={{ color: '#dfdfdf' }}>Data service and APIs</span>
      </Link>
    </li>
  </ul>
</li>

        <li onClick={() => setToggle('FAQ')}>
          <div className={`icon-link ${showClass == 'FAQ' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/FAQ")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-help-circle'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}> FAQ</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'FAQ' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('FAQ'); // Ensure the submodule stays open
            navigate("/FAQ")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-help-circle'></i>
                <span className={`${showClass != 'FAQ' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}> FAQ </span>
            </Link>
        </li>
    </ul>





        </li>

        <li onClick={() => setToggle('Data Policy')}>
          <div className={`icon-link ${showClass == 'Data Policy' ? "icon-link1" : ''}`}  onClick={() => {
      navigate("/DataPolicy")}}>
            <Link className="loginhere-link" >
              <i className='bx bx-lock-alt'></i>
              <span className="link_name" style={{color:'#dfdfdf'}}> Data Policy</span>
            </Link>

          </div>
          <ul className="sub-menu" style={{padding:'12px 12px ', backgroundColor:"rgba(31,41,53,255)"}}>
        <li className={`li-setting icon-link ${showClass == 'Data Policy' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
            e.stopPropagation();
            setShowClass('Data Policy'); // Ensure the submodule stays open
            navigate("/DataPolicy")
        }}>
            <Link className="loginhere-link" style={{padding: "0px 20px"}}>
                {/* Same icon for submodule */}
                <i className='bx bx-lock-alt'></i>
                <span className={`${showClass != 'Data Policy' ? "link_name1" : 'link_name2'}` } style={{color:'#dfdfdf'}}> Data Policy </span>
            </Link>
        </li>
    </ul>





        </li>
      </ul>
    </div>
  );
};

export default SideBar;

